import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Chat from "@/pages/Chat";
import { Toaster } from "@/components/ui/sonner";
import { trackVisit } from "@/lib/track";

const isChatRoute = () => typeof window !== "undefined" && window.location.pathname.replace(/\/+$/, "") === "/chat";

function App() {
  const chat = isChatRoute();

  useEffect(() => {
    if (!chat) trackVisit();
  }, [chat]);

  useEffect(() => {
    if (chat) return undefined;
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    // Smooth-scroll for in-page anchor links
    const onAnchorClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -90 });
        }
      }
    };
    document.addEventListener("click", onAnchorClick);

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
    };
  }, [chat]);

  return (
    <div className="App">
      {chat ? <Chat /> : <Landing />}
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
